var provinces = {
    //23个省
    "台湾": "taiwan",
    "河北省": 13,
    '石家庄市': 130100,
    '沧州市': 130900,
    '唐山市': 130200,
    '秦皇岛市': 130300,
    '邯郸市': 130400,
    '邢台市': 130500,
    '保定市': 130600,
    '张家口市': 130700,
    '承德市': 130800,
    '沧州市': 130900,
    '廊坊市': 131000,
    '衡水市': 131100,
    "山西省": 14,
    "辽宁省": 21,
    "吉林省": 22,
    "黑龙江省": 23,
    '黑龙江省农垦': 23,
    '北大荒农垦': 23,
    "江苏省": 32,
    "南京市": 320100,
    "盐城市": 320900,
    "徐州市": 320300,
    "南通市": 320600,
    "淮安市": 320800,
    "苏州市": 320500,
    "宿迁市": 321300,
    "扬州市": 321000,
    "连云港市": 320700,
    "泰州市": 321200,
    "无锡市": 320200,
    "常州市": 320400,
    "镇江市": 321100,
    "玄武区": 320102,
    "秦淮区": 320104,
    "建邺区": 320105,
    "鼓楼区": 320106,
    "浦口区": 320111,
    "栖霞区": 320113,
    "雨花台区": 320114,
    "江宁区": 320115,
    "六合区": 320116,
    "龙池街道": 320116,
    "溧水区": 320117,
    "高淳区": 320118,
    "锡山区": 320205,
    "惠山区": 320206,
    "滨湖区": 320211,
    "梁溪区": 320213,
    "新吴区": 320214,
    "江阴市": 320281,
    "宜兴市": 320282,
    "云龙区": 320303,
    "贾汪区": 320305,
    "泉山区": 320311,
    "铜山区": 320312,
    "丰县": 320321,
    "沛县": 320322,
    "睢宁县": 320324,
    "新沂市": 320381,
    "邳州市": 320382,
    "天宁区": 320402,
    "钟楼区": 320404,
    "新北区": 320411,
    "武进区": 320412,
    "金坛区": 320413,
    "溧阳市": 320481,
    "虎丘区": 320505,
    "吴中区": 320506,
    "相城区": 320507,
    "姑苏区": 320508,
    "吴江区": 320509,
    "常熟市": 320581,
    "张家港市": 320582,
    "昆山市": 320583,
    "太仓市": 320585,

    "浙江省": 33,
    "安徽省": 34,
    '合肥市': 340100,
    '芜湖市': 340200,
    '蚌埠市': 340300,
    '淮南市': 340400,
    '马鞍山市': 340500,
    '淮北市': 340600,
    '铜陵市': 340700,
    '安庆市': 340800,
    '黄山市': 341000,
    '滁州市': 341100,
    '阜阳市': 341200,
    '宿州市': 341300,
    '六安市': 341500,
    '亳州市': 341600,
    '池州市': 341700,
    '宣城市': 341800,
    "福建省": 35,
    "厦门市": 350200,
    "南平市": 350700,
    "江西省": 36,
    "山东省": 37,
    "河南省": 41,
    "湖北省": 42,
    "湖南省": 43,
    "广东省": 44,
    "海南省": 46,
    "四川省": 51,
    "贵州省": 52,
    "云南省": 53,
    "陕西省": 61,
    "甘肃省": 62,
    "青海省": 63,
    //5个自治区
    "新疆生产建设兵团": 71,
    "新疆维吾尔自治区": 71,
    "广西壮族自治区": 45,
    "内蒙古自治区": 15,
    "宁夏回族自治区": 64,
    "西藏自治区": 54,
    //4个直辖市
    "北京市": 11,
    "天津市": 12,
    "上海市": 31,
    "重庆市": 50,
    "青岛市": 370200000000,
    "即墨区": 370215,
    "市南区": 370202,
    "市北区": 370203,
    "黄岛区": 370211,
    "崂山区": 370212,
    "李沧区": 370213,
    "城阳区": 370214,
    "胶州市": 370281,
    "平度市": 370283,
    "莱西市": 370285,

    "济南市": 370100,
    '淄博市': 370300,
    '枣庄市': 370400,
    '东营市': 370500,
    '烟台市': 370600,
    '淮坊市': 370700,
    '济宁市': 370800,
    '泰安市': 370900,
    '威海市': 371000,
    '日照市': 371100,
    '临沂市': 371300,
    '德州市': 371400,
    '聊城市': 371500,
    '滨州市': 371600,
    '菏泽市': 371700,
    "南昌市": 360100,
    "南昌县": 360100,
    '景德镇市': 360200,
    '萍乡市': 360300,
    '九江市': 360400,
    '新余市': 360500,
    '鹰潭市': 360600,
    '赣州市': 360700,
    '吉安市': 360800,
    '宜春市': 360900,
    '福州市': 361000,
    '上饶市': 361100,
    //2个特别行政区
    "香港": "xianggang",
    "澳门": "aomen",
    "全国": 'china',
    "杭州市": 330100,
    "宁波市": 330200,
    "温州市": 330300,
    "嘉兴市": 330400,
    "湖州市": 330500,
    "绍兴市": 330600,
    "金华市": 330700,
    "衢州市": 330800,
    "台州市": 331000,
    
    "舟山市": 330900,
    "丽水市": 331100,
    "上城区": 330102,
    "下城区": 330103,
    "建德市": 330182,
    "余姚市": 330281,
    
    '岳阳市': 430600,
    '怀化市': 431200,
    '永州市': 431100,
    '邵阳市': 430500,
    '郴州市': 431000,
    '常德市': 430700,
    '衡阳市': 430400,
    '益阳市': 430900,
    '长沙市': 430100,
    '株洲市': 430200,
    '张家界市': 430800,
    '娄底市': 431300,
    '湘潭市': 430300,
    "汨罗市": 430681,
    '湘西土家族苗族自治州': 433100,
    // 新疆
    '乌鲁木齐市': 650100,
    "克拉玛依市": 650200,
    "吐鲁番市": 650400,
    "哈密市": 650500,
    "市辖区": 620200,
    "库尔勒经济技术开发区": 652801,
    "昌吉回族自治州": 652300,
    "博尔塔拉蒙古自治州": 652700,
    "巴音郭楞蒙古自治州": 652800,
    "阿克苏地区": 652900,
    "克孜勒苏柯尔克孜自治州": 653000,
    "喀什地区": 653100,
    "和田地区": 653200,
    "伊犁哈萨克自治州": 654000,
    "塔城地区": 654200,
    "阿勒泰地区": 654300,
    "天山区": 650100,
    "自治区直辖县级行政区划": 65,
    "沙依巴克区": 650103,
    "新市区": 650104,
    "水磨沟区": 650105,
    "头屯河区": 650106,
    "达坂城区": 650107,
    "米东区": 650109,
    "乌鲁木齐县": 650121,
    "独山子区": 650202,
    "克拉玛依区": 650203,
    "白碱滩区": 650204,
    "乌尔禾区": 650205,
    "高昌区": 650402,
    "鄯善县": 650421,
    "托克逊县": 650422,
    "巴里坤哈萨克自治县": 650521,
    "伊吾县": 650522,
    "昌吉市": 652301,
    "阜康市": 652302,
    "呼图壁县": 652323,
    "玛纳斯县": 652324,
    "奇台县": 652325,
    "吉木萨尔县": 652327,
    "木垒哈萨克自治县": 652328,
    "博乐市": 652701,
    "阿拉山口市": 652702,
    "精河县": 652722,
    "温泉县": 652723,
    "库尔勒市": 652801,
    "轮台县": 652822,
    "尉犁县": 652823,
    "若羌县": 652824,
    "且末县": 652825,
    "焉耆回族自治县": 652826,
    "和静县": 652827,
    "和硕县": 652828,
    "博湖县": 652829,
    "阿克苏市": 652901,
    "库车市": 652923,
    "温宿县": 652922,
    "沙雅县": 652924,
    "新和县": 652925,
    "拜城县": 652926,
    "乌什县": 652927,
    "阿瓦提县": 652928,
    "柯坪县": 652929,
    "阿图什市": 653001,
    "阿克陶县": 653022,
    "阿合奇县": 653023,
    "乌恰县": 653024,
    "喀什市": 653101,
    "疏附县": 653121,
    "疏勒县": 653122,
    "英吉沙县": 653123,
    "泽普县": 653124,
    "莎车县": 653125,
    "叶城县": 653126,
    "麦盖提县": 653127,
    "岳普湖县": 653128,
    "伽师县": 653129,
    "巴楚县": 653130,
    "和田市": 653201,
    "塔什库尔干塔吉克自治县": 653131,
    "和田县": 653221,
    "墨玉县": 653222,
    "皮山县": 653223,
    "洛浦县": 653224,
    "策勒县": 653225,
    "于田县": 653226,
    "民丰县": 653227,
    "伊宁市": 654002,
    "奎屯市": 654003,
    "霍尔果斯市": 654004,
    "伊宁县": 654021,
    "察布查尔锡伯自治县": 654022,
    "霍城县": 654023,
    "巩留县": 654024,
    "新源县": 654025,
    "昭苏县": 654026,
    "特克斯县": 654027,
    "尼勒克县": 654028,
    "塔城市": 654201,
    "乌苏市": 654202,
    "额敏县": 654221,
    "沙湾市": 654223,
    "托里县": 654224,
    "裕民县": 654225,
    "和布克赛尔蒙古自治县": 654226,
    "阿勒泰市": 654301,
    "布尔津县": 654321,
    "富蕴县": 654322,
    "福海县": 654323,
    "哈巴河县": 654324,
    "青河县": 654325,
    "吉木乃县": 654326,
    "石河子市": 659001,
    "阿拉尔市": 659002,
    "图木舒克市": 659003,
    "五家渠市": 659004,
    "北屯市": 659005,
    "铁门关市": 659006,
    "双河市": 659007,
    "可克达拉市": 659008,
    "昆玉市": 659009,
  }
  export default provinces


// WEBPACK FOOTER //
// ./src/components/Index/common/city.js